import { MARQUEE_ITEMS } from '../data/site';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-navy py-4 marquee-mask" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.2em] text-slate-300">
            {item}
            <span className="h-1.5 w-1.5 rotate-45 bg-sky-400" />
          </span>
        ))}
      </div>
    </div>
  );
}
